import { Modal } from '../modal';
import Body from './body';
import DialogInternal from './dialog-internal';
import Footer from './footer';
import Header from './header';
var DialogNamespace = Object.assign(DialogInternal, {
    Body: Body,
    Button: Modal.Button,
    CloseButton: Modal.CloseButton,
    Footer: Footer,
    Header: Header,
});
export default DialogNamespace;
